export default {
  app: {
    title: "Коробка слов мечты",
    language: "Русский"
  },

  pages: {
    app: {
      myAccount: "Мой аккаунт",
      editProfile: "Редактировать профиль",

      boxScenarios: "Сценарии коробок",
      scenario1Title: "Полудневная коробка",
      scenario1Desc: "Повторяйте коробку каждые полдня (например, утром и вечером).",

      scenario2Title: "Ежедневная коробка",
      scenario2Desc: "Повторяйте коробку один раз в день.",

      scenario3Title: "Дни по номеру коробки",
      scenario3Desc: "Повторяйте коробку в зависимости от её номера (например, коробку 3 — каждые 3 дня).",

      username: "Имя пользователя",
      usernameHint: "Ваш уникальный логин для входа",

      name: "Имя",
      nameHint: "Как к вам обращаться?",

      email: "Электронная почта",
      emailHint: "Почта для восстановления пароля (необязательно)",

      changePassword: "Изменить пароль",
      changePasswordHint: "Если вы не хотите менять пароль, оставьте это поле пустым (необязательно)",

      logout: "Выйти",
      confirmLogout: "Подтвердить выход",
      confirmLogoutText: "Вы уверены, что хотите выйти?",
      cancel: "Отмена",

      close: "Закрыть",
      updateProfile: "Обновить профиль",

      myWords: "Мои слова",
      addNewWord: "Добавить новое слово / выражение",
      boxes: "Коробки",

      applicationSettings: "Настройки приложения",

      autoSpeechOnChecking: "Автоматически озвучивать слово при показе",
      autoDetectClipboardChange: "Автоматически определять текст из буфера обмена",

      clipboardPermissionText: "Приложению нужен доступ к буферу обмена в настройках браузера. Для получения помощи нажмите здесь.",

      clipboardHelpTitle: "Как включить доступ к буферу обмена",

      chrome: "Chrome",
      firefox: "Firefox",
      safari: "Safari",

      chromeStep1: "Откройте браузер Chrome.",
      chromeStep2: "Перейдите в настройки браузера.",
      chromeStep3: "Найдите раздел Настройки сайта или Настройки.",
      chromeStep4: "Откройте раздел Разрешения и включите буфер обмена.",

      firefoxStep1: "Откройте браузер Firefox.",
      firefoxStep2: "Перейдите в настройки браузера.",
      firefoxStep3: "Найдите раздел Разрешения и включите доступ к буферу обмена.",

      safariStep1: "Откройте приложение Настройки на телефоне.",
      safariStep2: "Перейдите в Safari.",
      safariStep3: "Найдите настройки, связанные с буфером обмена, и включите их.",

      otherBrowserTitle: "Если вы используете другой браузер",
      otherBrowserStep1: "Найдите похожую опцию Разрешения или Настройки сайта в настройках браузера и включите доступ к буферу обмена.",

      speechNotSupported: "Ваш браузер не поддерживает SpeechSynthesis",

      ttsSettings: "Настройки синтеза речи",
      sampleText: "Текст для проверки озвучивания",

      rate: "Скорость",
      rateHint: "Управляет скоростью речи.",

      pitch: "Высота тона",
      pitchHint: "Настраивает высоту голоса.",

      volume: "Громкость",
      volumeHint: "Устанавливает громкость речи.",

      friends: "Друзья",
      messages: "Сообщения",

      addToMyWords: "Добавить {word} в мои слова",
      viewInMyList: "Посмотреть {word} в моём списке",

      wordSuggestion: "Предложение слова",
      goToAddWord: "Перейти к добавлению нового слова",

      updateCompleted: "Обновление успешно завершено",
      latestChanges: "Последние изменения в недавних версиях",
      version: "Версия",
      gotIt: "Понятно"
    },

    addVocabulary: {
      title: "Добавить новое слово",
      add: "Добавить",
      word: "Слово / фраза",
      meaning: "Значение",
      example: "Пример",
      description: "Описание"
    },

    vocabularies: {
      searchLabel: "Поиск текста",
      listLength: "Длина списка",
      boxNumber: "Номер коробки",
      nothingFound: "Ничего не найдено !!!",
      adjustFilters: "Попробуйте изменить фильтры",
      tableWord: "Слово",
      tableAction: "Действие",
      showDetails: "Показать детали",
      completeInfo: "Полная информация",
      meaning: "Значение",
      example: "Пример",
      description: "Описание",
      close: "Закрыть",
      editTitle: "Редактировать",
      editBtn: "Редактировать",
      deleteTitle: "Удалить {word}",
      deleteConfirmText: "Вы уверены, что хотите удалить это слово? Обратите внимание, что после удаления его нельзя будет восстановить.",
      yes: "Да!",
      no: "Нет"
    },

    messages: {
      wordSuggestions: "Предложения слов"
    },

    login: {
      signInTitle: "Войти",
      signInBtn: "Войти",
      registerTitle: "Регистрация",
      registerBtn: "Зарегистрироваться",
      registerLink: "Регистрация",
      username: "Имя пользователя",
      password: "Пароль",
      nickname: "Имя",
      email: "Электронная почта",
      noAccount: "Ещё не зарегистрированы?",
      haveAccount: "У меня уже есть аккаунт.",
      usernameHint: "Ваш уникальный логин для входа",
      nicknameHint: "Как к вам обращаться?",
      emailHint: "Почта для восстановления пароля (необязательно)",
      passwordHint: "Пароль без правил, введите что угодно",
      orContinueWith: "Или продолжить с...",
      guestRegister: "Быстрая регистрация как гость 😒"
    },

    reviewVocabulary: {
      showMeaning: "Показать значение",
      hideMeaning: "Скрыть значение",
      meaning: "Значение",
      example: "Пример",
      description: "Описание",
      playPhrase: "PlayPhrase.me",
      prev: "Назад",
      next: "Далее"
    },

    checkVocabulary: {
      showMeaning: "Показать значение",
      hideMeaning: "Скрыть значение",
      wordsRemain: "Осталось слов",
      lastOne: "Последнее",
      meaning: "Значение",
      example: "Пример",
      description: "Описание",
      playPhrase: "PlayPhrase.me",
      iRemember: "Помню",
      iDontRemember: "Не помню"
    },

    boxes: {
      all: "Показать все коробки",
      box: "Коробка",
      empty: "Пусто",
      needsChecking: "Требует проверки",
      checked: "Проверено",

      total: "Всего",
      waiting: "Ожидание",
      waitingForCheck: "Ожидает проверки",

      closestReview: "Ближайшее повторение",
      notScheduled: "Пока не запланировано",

      deeplyMemorized: "Вы хорошо запомнили {count} слов.",
      notReachedYet: "Упс! Вы ещё не дошли до этой коробки.",

      startChecking: "Начать проверку",
      review: "Повторить",
      viewAllWords: "Показать все слова",
      addNew: "Добавить новое",
      itsEmpty: "Пусто"
    },

    friends: {
      searchInUsers: "Поиск среди пользователей",
      searchList: "Список поиска",
      noUsersYet: "Пользователей пока нет.",
      searchUsersAndSendRequest: "Вы можете искать пользователей и отправлять запросы в друзья",
      friendList: "Список друзей",
      noFriendsYet: "Друзей пока нет."
    }
  },

  plugins: {
    axios: {
      postRequestError: "Произошла ошибка при отправке запроса"
    }
  },

  components: {
    shareButton: {
      shareTitle: "Поделиться {word}",
      messageOptional: "Сообщение (необязательно)"
    },

    userList: {
      cancelRequest: "Отменить запрос",
      unfriend: "Удалить из друзей",
      sendRequest: "Отправить запрос",
      accept: "Принять",
      reject: "Отклонить",

      share: "Поделиться",
      addedBefore: "Уже было добавлено ранее",

      deeplyMemorized: "{name} хорошо запомнил(а) {count} слов.",
      notReachedBox: "{name} ещё не дошёл(ла) до этой коробки.",

      totalVocabularies: "Всего слов",
      registerAge: "Срок регистрации",
      lastCheck: "Последняя проверка",
      lastAddedVocabulary: "Последнее добавленное слово",
      totalChecks: "Всего проверок",
      averageDailyCheck: "Среднее количество проверок в день",
      averageDailyLearnedCheck: "Среднее количество изуенных проверок в день",
      averageDailyNotLearnedCheck: "Среднее количество невыученных проверок в день",
      averageDailyAdd: "Среднее количество добавлений в день"
    }
  },

  public: {
    close: "Закрыть"
  },
  "apiResultStatusCodes": {
    "0": "Операция не выполнена",
    "1": "Операция выполнена успешно",
    "2": "Произошла ошибка",
    "3": "Переданы неверные параметры",
    "4": "Не найдено",
    "5": "Ошибка аутентификации",
    "6": "Этот элемент уже зарегистрирован",
    "7": "Этот пользователь уже зарегистрирован",
    "8": "Указанный пользователь не существует",
    "9": "Неверный пароль",
    "10": "Неверные параметры",
    "11": "Ошибка входа",
    "12": "Доступ запрещён",
    "13": "Элемент не найден",
    "14": "Это имя пользователя уже занято",
    "15": "Этот email уже используется",
    "16": "Имя пользователя обязательно",
    "17": "Никнейм обязателен",
    "18": "Пароль обязателен",
    "19": "Имя пользователя не может содержать пробелы",
    "20": "Регистрация успешно завершена",
    "21": "Вход выполнен успешно",
    "22": "Пароль не может содержать пробелы",
    "23": "Слово успешно добавлено",
    "24": "Слово успешно обновлено",
    "25": "Слово успешно удалено",
    "26": "Вы уже добавили это слово",
    "27": "Слово обязательно",
    "28": "Слова не найдены",
    "29": "Поздравляем! Все слова в этой коробке проверены",
    "30": "Вы не можете изменить поле слова",
    "31": "Пожалуйста, заполните обязательные поля",
    "32": "Изменений не обнаружено",
    "33": "Указанный пользователь не существует в репозитории",
    "34": "Запрос в друзья успешно отправлен",
    "35": "Запрос в друзья успешно принят",
    "36": "Запрос в друзья успешно отменён",
    "37": "Вы успешно удалили пользователя из друзей",
    "38": "Вы успешно отклонили запрос",
    "39": "Сообщение успешно отправлено"
  },
  "time": {
    "day": "день | дней",
    "hour": "час | часов",
    "minute": "минута | минут"
  }


}
